(function () {
  class PTabThumbs extends HTMLElement {
    getThumbDirection() {
      return this.mobileMql && this.mobileMql.matches ? "horizontal" : "vertical";
    }

    createThumbSwiper() {
      this.thumbSwiper = new Swiper(this.thumbsEl, {
        direction: this.getThumbDirection(),
        slidesPerView: "auto",
        spaceBetween: 10,
        watchSlidesProgress: true,
        breakpoints: {
          320: {
            slidesPerView: 5,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 10,
          }
        }
      });
    }

    updateThumbSwiperDirection() {
      if (!this.thumbSwiper) return;
      const nextDirection = this.getThumbDirection();
      if (this.thumbSwiper.params.direction === nextDirection) return;

      const activeIndex = this.contentSwiper ? this.contentSwiper.activeIndex : this.thumbSwiper.activeIndex;
      this.thumbSwiper.destroy(true, true);
      this.createThumbSwiper();
      this.thumbSwiper.slideTo(activeIndex, 0);
      this.syncActive(activeIndex);
    }

    connectedCallback() {
      this.waitForSwiper(() => {
        if (!this.isConnected || this.inited) return;
        this.inited = true;
        this.init();
      });
    }

    disconnectedCallback() {
      this.destroy();
      this.inited = false;
    }

    waitForSwiper(callback, retry = 0) {
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (retry > 40) return;
      setTimeout(() => this.waitForSwiper(callback, retry + 1), 100);
    }

    init() {
      this.thumbsEl = this.querySelector("[data-ptt-thumbs]");
      this.contentEl = this.querySelector("[data-ptt-content]");
      this.copyEl = this.querySelector("[data-ptt-copy]");
      if (!this.thumbsEl || !this.contentEl || !this.copyEl) return;

      this.tabButtons = Array.from(this.querySelectorAll(".p-tab-thumbs__tab"));
      this.thumbButtons = Array.from(this.querySelectorAll(".p-tab-thumbs__thumb"));
      this.contentSwiperPrev = this.querySelector(".ptt-thumbs-swiper__btn-prev");
      this.contentSwiperNext = this.querySelector(".ptt-thumbs-swiper__btn-next");
      this.mobileMql = window.matchMedia("(max-width: 989px)");
      this.reduceMotionMql = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.autoplayEnabled = this.dataset.autoplay === "true";
      this.autoplayInterval = Math.max(1, Number(this.dataset.autoplayInterval || 5)) * 1000;
      this.autoplayStoppedByUser = false;
      this.autoplayTimer = null;

      this.createThumbSwiper();

      this.contentSwiper = new Swiper(this.contentEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        speed: 450,
        navigation: {
          nextEl: this.contentSwiperNext,
          prevEl: this.contentSwiperPrev
        }
      });
      this.copySwiper = new Swiper(this.copyEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        speed: 450,
      });

      this.bindEvents();
      this.syncActive(0);
      this.startAutoplay();
    }

    bindEvents() {
      this.stopAutoplayOnUser = () => {
        this.stopAutoplay(true);
      };

      this.onTabClick = (event) => {
        this.stopAutoplayOnUser();
        const button = event.currentTarget;
        const index = Number(button.dataset.index || 0);
        this.goToIndex(index, "tab");
      };

      this.onThumbClick = (event) => {
        this.stopAutoplayOnUser();
        const button = event.currentTarget;
        const index = Number(button.dataset.index || 0);
        this.goToIndex(index, "thumb");
      };

      this.onContentChange = () => {
        this.goToIndex(this.contentSwiper.activeIndex, "content");
      };
      this.onCopyChange = () => {
        this.goToIndex(this.copySwiper.activeIndex, "copy");
      };
      this.onViewportChange = () => {
        if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = requestAnimationFrame(() => {
          this.updateThumbSwiperDirection();
          this.resizeRaf = null;
        });
      };

      this.tabButtons.forEach((button) => button.addEventListener("click", this.onTabClick));
      this.thumbButtons.forEach((button) => button.addEventListener("click", this.onThumbClick));
      if (this.contentSwiperPrev) {
        this.contentSwiperPrev.addEventListener("click", this.stopAutoplayOnUser);
      }
      if (this.contentSwiperNext) {
        this.contentSwiperNext.addEventListener("click", this.stopAutoplayOnUser);
      }
      this.contentSwiper.on("slideChange", this.onContentChange);
      this.contentSwiper.on("touchStart", this.stopAutoplayOnUser);
      this.copySwiper.on("slideChange", this.onCopyChange);
      this.copySwiper.on("touchStart", this.stopAutoplayOnUser);
      this.mobileMql.addEventListener("change", this.onViewportChange);
      this.onVisibilityChange = () => {
        if (document.hidden) {
          this.stopAutoplayTimer();
          return;
        }
        this.startAutoplay();
      };
      document.addEventListener("visibilitychange", this.onVisibilityChange);
    }

    canAutoplay() {
      if (!this.autoplayEnabled || this.autoplayStoppedByUser) return false;
      if (this.reduceMotionMql && this.reduceMotionMql.matches) return false;
      if (!this.tabButtons || this.tabButtons.length < 2) return false;
      if (document.hidden) return false;
      return true;
    }

    startAutoplay() {
      this.stopAutoplayTimer();
      if (!this.canAutoplay()) return;

      this.autoplayTimer = window.setInterval(() => {
        if (!this.canAutoplay() || !this.contentSwiper) {
          this.stopAutoplayTimer();
          return;
        }
        const current = this.contentSwiper.activeIndex || 0;
        const next = (current + 1) % this.tabButtons.length;
        this.goToIndex(next, "autoplay");
      }, this.autoplayInterval);
    }

    stopAutoplayTimer() {
      if (!this.autoplayTimer) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    stopAutoplay(byUser) {
      if (byUser) this.autoplayStoppedByUser = true;
      this.stopAutoplayTimer();
    }

    goToIndex(index, source) {
      if (this.isSyncing) return;
      this.isSyncing = true;

      if (source !== "content" && this.contentSwiper && this.contentSwiper.activeIndex !== index) {
        this.contentSwiper.slideTo(index);
      }
      if (source !== "copy" && this.copySwiper && this.copySwiper.activeIndex !== index) {
        this.copySwiper.slideTo(index);
      }
      if (this.thumbSwiper && this.thumbSwiper.activeIndex !== index) {
        this.thumbSwiper.slideTo(index);
      }
      this.syncActive(index);

      this.isSyncing = false;
    }

    syncActive(index) {
      this.tabButtons.forEach((button, i) => {
        button.classList.toggle("is-active", i === index);
      });
      this.thumbButtons.forEach((button, i) => {
        button.classList.toggle("is-active", i === index);
      });
    }

    destroy() {
      this.stopAutoplayTimer();

      if (this.tabButtons && this.onTabClick) {
        this.tabButtons.forEach((button) => button.removeEventListener("click", this.onTabClick));
      }
      if (this.thumbButtons && this.onThumbClick) {
        this.thumbButtons.forEach((button) => button.removeEventListener("click", this.onThumbClick));
      }
      if (this.contentSwiperPrev && this.stopAutoplayOnUser) {
        this.contentSwiperPrev.removeEventListener("click", this.stopAutoplayOnUser);
      }
      if (this.contentSwiperNext && this.stopAutoplayOnUser) {
        this.contentSwiperNext.removeEventListener("click", this.stopAutoplayOnUser);
      }

      if (this.contentSwiper) {
        this.contentSwiper.off("slideChange", this.onContentChange);
        this.contentSwiper.off("touchStart", this.stopAutoplayOnUser);
        this.contentSwiper.destroy(true, true);
      }
      if (this.copySwiper) {
        this.copySwiper.off("slideChange", this.onCopyChange);
        this.copySwiper.off("touchStart", this.stopAutoplayOnUser);
        this.copySwiper.destroy(true, true);
      }
      if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);
      if (this.mobileMql && this.onViewportChange) {
        this.mobileMql.removeEventListener("change", this.onViewportChange);
      }
      if (this.onVisibilityChange) {
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
      }
      if (this.resizeRaf) {
        cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = null;
      }

      this.thumbSwiper = null;
      this.contentSwiper = null;
      this.copySwiper = null;
      this.mobileMql = null;
    }
  }

  if (!customElements.get("p-tab-thumbs")) {
    customElements.define("p-tab-thumbs", PTabThumbs);
  }
})();
